import React, { useState } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';

import { defaultFields, setDefaultValues, validationPassed } from './helpers';

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

function Exports() {
  const [formData, setFormData] = useState({
    program: 'pip',
    applicableYears: [currentYear],
    projectStatuses: wlPipAdmin.projectStatuses,
    ...setDefaultValues(defaultFields)
  });
  const [loading, setLoading] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [errors, setErrors] = useState(null);

  const handleToggleFields = () => {
    setShowFields(!showFields);
  };

  const handleCheckboxChange = ({ target: { name, value, checked } }) => {
    value = name === 'applicableYears' ? parseInt(value) : value;
    const isChecked = checked;

    setFormData((prevFormData) => {
      if (isChecked) {
        return {
          ...prevFormData,
          [name]: [...prevFormData[name], value]
        };
      } else {
        return {
          ...prevFormData,
          [name]: prevFormData[name].filter((prevValue) => prevValue !== value)
        };
      }
    });
  };

  const handleSubmit = () => {
    setErrors(null);
    setLoading(true);

    if (!validationPassed(formData)) {
      setLoading(false);
      setErrors(
        'Please make sure you choose at least one year, status and field to be exported.'
      );
      return;
    }

    axios
      .post(
        `${wlPipConfig.ajaxUrl}?action=wl_incentive_pgrm_export`,
        formData,
        {
          responseType: 'blob'
        }
      )
      .then((response) => {
        const filename = response.headers['content-disposition'].split('=')[1];
        const url = window.URL.createObjectURL(new Blob([response.data]));
        saveAs(url, filename);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const errorStatus = error.response.status;
        const defaultError =
          'Something went wrong and the request could not be processed.';

        if (404 == errorStatus) {
          if (error.response.data instanceof Blob) {
            error.response.data.text().then((errorMessage) => {
              const parsedErrorMessage = JSON.parse(errorMessage);
              setErrors(parsedErrorMessage.data.message || defaultError);
            });
          }
        } else {
          setErrors(defaultError);
        }
      });
  };

  return (
    <div className="grid" style={{ maxWidth: '800px' }}>
      <div className="grid__col-xs-12">
        <div className="form__field">
          <label className="form__label">Applicable Years</label>
          <small className="form__help">
            Select the years for the projects you want exported.
          </small>
          {wlPipAdmin.applicableYears.map((year) => (
            <label key={year} className="form__checkbox">
              <input
                type="checkbox"
                name="applicableYears"
                value={year}
                checked={
                  formData.applicableYears.includes(year) === true
                    ? 'checked'
                    : ''
                }
                onChange={handleCheckboxChange}
              />
              {year}
            </label>
          ))}
        </div>
      </div>
      <div className="grid__col-xs-12">
        <div className="form__field">
          <label className="form__label">Status</label>
          <small className="form__help">
            Select the statuses for the projects you want exported.
          </small>
          {wlPipAdmin.projectStatuses.map((status) => (
            <label key={status} className="form__checkbox">
              <input
                type="checkbox"
                value={status}
                name="projectStatuses"
                checked={
                  formData.projectStatuses.includes(status) === true
                    ? 'checked'
                    : ''
                }
                onChange={handleCheckboxChange}
              />
              {status}
            </label>
          ))}
        </div>
      </div>
      <div className="grid__col-xs-12">
        <div className="form__field">
          <label
            className={`form__label`}
            onClick={handleToggleFields}
            style={{ cursor: 'pointer' }}
          >
            Choose which fields you want in the export
            <span className={`caret caret--${showFields ? 'up' : 'down'}`}>
              &#x25BC;
            </span>
          </label>
          <small className="form__help">
            You can choose which fields are included in the export.
          </small>
          <div
            id="checkboxContainer"
            className={`checkbox-container ${showFields ? 'show' : ''}`}
          >
            {showFields &&
              defaultFields.map((field) => (
                <label key={field} className="form__checkbox">
                  <input
                    type="checkbox"
                    checked={formData[field] === true ? 'checked' : ''}
                    onChange={() =>
                      setFormData({ ...formData, [field]: !formData[field] })
                    }
                  />
                  {field}
                </label>
              ))}
          </div>
        </div>
      </div>
      <div className="grid__col-xs-12">
        <div className={`form__field}`}>
          <div className="form__submit">
            <button
              className={`btn btn--primary ${loading && 'btn--loading'}`}
              type="button"
              onClick={handleSubmit}
            >
              <span className="btn__content">
                <span className="btn__text">Submit</span>
              </span>
            </button>
            {errors && (
              <span className="form__help u--color-red u--margin-top-10">
                {errors}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Exports;
